import Turbolinks from 'turbolinks';
import chatNotificationSound from 'lib/audio';

document.addEventListener('chatMenu-exited', (e) => {
  if (window.location.pathname.includes(e.detail.chatId)) {
    Turbolinks.visit('/chats', { action: 'replace' });
  }
});

document.addEventListener('message-global-received', () => {
  chatNotificationSound();
});

// The "start a new chat" modal submits via AJAX. Navigate straight from the event
// rather than stashing the URL in App.modalData, which went stale when the modal
// was dismissed mid-request. App.Modal.create fires this before hiding the modal,
// so a missing modal means the user cancelled: stay put.
$(document).on('chat.create.fm', (e, data) => {
  if (!$('.form-modal').length) return;

  Turbolinks.visit(data.params.chat_url);
});
